export const FILE_STORAGE_WARNING = 'La carga del documento aún no está disponible. No fue posible conectar con el almacenamiento de archivos. Intente nuevamente.';

/** Distinguish storage outages from validation, permissions and other API errors. */
export function isFileStorageError(error: unknown): boolean {
  const response = error as {status?: number; error?: {response?: {message?: string}}} | null;
  return response?.status === 503 && /\bS3\b|almacenamiento/i.test(response.error?.response?.message ?? '');
}
